import { AccessCodeService, OrganizationsService } from '@shared/core';
import { Component } from '@angular/core';
import { LayoutCollapseSideNavAction } from '@shared/store/actions/layout-actions';
import {
	getLayoutEnableAdminOptions,
	getLayoutIsAdminMenu,
	getLayoutScopeId,
	getOrganizationAll,
	getOrganizationById
} from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import * as _moment from 'moment'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { Subscription } from 'rxjs';
import { map, mergeMap, switchMap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { PreventableEvent } from '@progress/kendo-angular-buttons';

@Component({
	selector: 'spaq-layout-account-header',
	templateUrl: './layout-account-header.component.html',
	styleUrls: ['./layout-account-header.component.scss']
})
export class LayoutAccountHeaderComponent {
	adminOrganizationList$ = this.organizationService.getAll(true);
	adminSelectedOrganization$ = this.organizationService.selectedOrganization$;
	adminSelectedGroup$ = this.organizationService.selectedGroup$;
	adminSelectedOrganizationGroups$ = this.organizationService.getSelectedOrganizationGroups(true);

	isAdminMenu$ = this.store.pipe(select(getLayoutIsAdminMenu));
	scopeId$ = this.store.pipe(select(getLayoutScopeId));
	organization$ = this.scopeId$.pipe(
		switchMap(id =>
			this.store.pipe(
				select(getOrganizationById, id),
				map(x => (x && x.organizationName) || 'Public')
			)
		)
	);
	organizationList$ = this.store.pipe(
		select(getOrganizationAll),
		map(x => [...x])
	);
	enableAdminOptions$ = this.store.pipe(select(getLayoutEnableAdminOptions));

	states = {
		error: 0,
		success: 0,
		pending: 0
	};
	status = {
		idle: false,
		payment: false,
		vault: false,
		contract: false,
		pdf: false,
		preauth: false
	};
	subscription: Subscription;

	constructor(
		public organizationService: OrganizationsService,
		private accessCodeService: AccessCodeService,
		private afAuth: AngularFireAuth,
		private store: Store<any>
	) {}
	private keepOrganizationPopupOpen = false;

	isOrganizationDisabled(organization: any): boolean {
		return organization?.organizationCode === 'CEM';
	}

	onOrganizationItemMouseDown(organization: any): void {
		this.keepOrganizationPopupOpen = this.isOrganizationDisabled(organization);
	}

	onOrganizationPopupClose(event: PreventableEvent): void {
		if (this.keepOrganizationPopupOpen) {
			event.preventDefault();
			this.keepOrganizationPopupOpen = false;
		}
	}

	onOrganizationClick(organization: any) {
		if (this.isOrganizationDisabled(organization)) {
			return;
		}
		if (!organization.organizationCode) {
			localStorage.removeItem('selectedOrganization');
			return this.afAuth.user
				.pipe(
					take(1),
					mergeMap(u => this.accessCodeService.resetForOrganizationChange(u.uid)),
					take(1)
				)
				.subscribe(() => {
					location.reload();
				});
		}
		localStorage.setItem('selectedOrganization', organization.organizationCode);
		return this.afAuth.user
			.pipe(
				take(1),
				mergeMap(u => this.accessCodeService.resetForOrganizationChange(u.uid)),
				take(1)
			)
			.subscribe(() => {
				location.reload();
			});
	}
	collapse() {
		this.store.dispatch(new LayoutCollapseSideNavAction(null, Date.now()));
	}
}
